import type { FaireProductEntity } from "../../entity_types/product";

export const p_djdymc63sz: FaireProductEntity = {
  token: "p_djdymc63sz",
  type: "product",
  name: "Gemstone Planets in Organza Bag .",
  brandToken: "b_6l28vptlbv",
  brandName: "Puka Creations",
  imageUrl:
    "https://cdn.faire.com/fastly/407f5defb08fae4992424a4abded24fa66a20b4ff08aed35e62f483f3e3db36a.webp",
  galleryImageUrls: [],
  priceDollars: 3.46,
  description:
    "Explore the universe with our Gemstone Planets set by Puka Creations. Each set includes an organza bag with miniature gemstone representations of the planets. Perfect for those who appreciate spirituality and beauty, these gemstones make a unique decor piece. Experience the universe in the palm of your hand with our Gemstone Planets.",
  tags: [],
  msrpDollars: 8.66,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:19.976Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
